import React from 'react';
import type { SelectionBox as SelectionBoxType } from '../hooks/useTransformable';

interface SelectionBoxProps {
  selection: SelectionBoxType | null;
}

export const SelectionBox: React.FC<SelectionBoxProps> = ({ selection }) => {
  if (!selection) return null;

  return (
    <div
      style={{
        position: 'absolute',
        left: selection.x,
        top: selection.y,
        width: selection.width,
        height: selection.height,
        border: '1px dashed #007bff',
        backgroundColor: 'rgba(0, 123, 255, 0.1)',
        pointerEvents: 'none',
      }}
    />
  );
};
